import { Cross } from "@taroify/icons/index.js";
import classNames from "classnames";
import * as React from "react";
import { useContext } from "react";
import { prefixClassname } from "../styles/index.js";
import PopupContext from "./popup.context.js";
function usePopupClosePlacement(placement) {
    const { placement: ctxPlacement } = useContext(PopupContext);
    if (placement) {
        return placement;
    }
    if (ctxPlacement === "right") {
        return "top-left";
    }
    return "top-right";
}
export default function PopupClose(props) {
    const { children = React.createElement(Cross, null) } = props;
    const { onClose } = useContext(PopupContext);
    const placement = usePopupClosePlacement(props.placement);
    if (React.isValidElement(children)) {
        const iconElement = children;
        return React.cloneElement(iconElement, {
            className: classNames(iconElement.props.classNames, prefixClassname("popup__close-icon"), {
                [prefixClassname("popup__close-icon--top-left")]: placement === "top-left",
                [prefixClassname("popup__close-icon--top-right")]: placement === "top-right",
                [prefixClassname("popup__close-icon--bottom-left")]: placement === "bottom-left" || placement === "bottom-right",
            }),
            onClick: () => onClose?.(false),
        });
    }
    return React.createElement(React.Fragment, null, children);
}
